import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Axios from "axios";
import { store } from "./store";
import { API_ROOT } from "./config";
import vuetify from "./plugins/vuetify";
import { handleRedirectPromise, isMsalConfigured } from "./auth/msal";

window.active_system = "osbod_student";
window._ = require("lodash");
window.S = require("string");

window.ax = Axios.create({
  baseURL: API_ROOT.osbod_salary,
  timeout: 60000
});

Vue.config.productionTip = false;

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

function mountApp() {
  new Vue({
    router: router,
    store: store,
    vuetify: vuetify,
    render: function(h) {
      return h(App);
    }
  }).$mount("#app");
}

// Process Entra redirect before Vue/router touch the URL
if (isMsalConfigured()) {
  handleRedirectPromise()
    .catch(function(err) {
      console.error("MSAL redirect error:", err);
      window.__msalRedirectError =
        (err && err.message) || "Microsoft redirect mislukt";
    })
    .finally(function() {
      mountApp();
    });
} else {
  mountApp();
}
